<script lang="ts" setup>
const tabs = ['Stake', 'Unstake']
const tab = ref(tabs[0])

function setTab(tabName: string) {
  tab.value = tabName
}

provide('setTab', setTab)
</script>

<template>
  <div class="stake-box">
    <div class="stake-box__top">
      <q-tabs v-model="tab" class="default-tab" :animated="false">
        <q-tab v-for="t in tabs" :key="t" :name="t" :label="t" />
      </q-tabs>

      <epoch-badge class="epoch-badge-default" />
    </div>

    <q-tab-panels v-model="tab" :animated="false" class="stake-wrapper">
      <q-tab-panel name="Stake">
        <stake-card />
      </q-tab-panel>
      <q-tab-panel name="Unstake">
        <unstake-card />
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<style lang="scss">
.stake-box {
  max-width: 472px;
  width: 100%;
  height: 490px;
  border-radius: 10px;
  background: $base-white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(16px);
  padding: 24px 30px 34px 30px;
  display: flex;
  flex-direction: column;

  @media (max-width: $breakpoint-md) {
    box-shadow: none;
  }

  @media (max-width: $breakpoint-sm) {
    width: 100%;
    max-width: 100%;
    padding: 16px 10px;
    order: -1;
  }

  @media (max-width: $breakpoint-xs) {
    padding: 8px 4px;
    height: fit-content;
  }

  .stake-box__top {
    height: 50px;
  }
  .q-tabs__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    place-content: center;
    height: 38px;
  }

  .q-focus-helper {
    display: none;
  }

  .q-tab__indicator {
    display: none;
  }

  .q-tab__content {
    padding: 0;
    height: 100%;
    position: relative;
    z-index: 1;
    align-self: baseline;
  }

  .epoch-badge-linear {
    display: none;
  }

  @media (max-width: $breakpoint-xs) {
    .epoch-badge-default {
      display: none;
    }

    .epoch-badge-linear {
      display: flex;
      padding: 16px 10px 0 0;
    }
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 24px;

    @media (max-width: $breakpoint-xs) {
      margin-bottom: 20px;
    }

    .q-tabs {
      width: 100%;
    }

    .default-tab {
      width: 100%;
      border-radius: $border-radius-lg;
      padding: 6px;
      background-color: #f6f6f6;

      @media (max-width: $breakpoint-xs) {
        width: 100%;
      }

      .q-tab {
        padding: 13px 10px;
        border-radius: $border-radius-lg;
        min-height: unset;

        &.q-tab--active {
          background-color: $base-white;
        }

        .q-tab__label {
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.56px;
          line-height: 1;
        }
      }
    }
  }
  .q-tab-panel {
    padding: 0;
  }

  &:not(:has(.unstake-card)) {
    overflow: initial;
  }
}
</style>
